import moment from "moment";
import { updateGlobalLoader } from "../../../components/backdrop/backdropSlice";
import { api } from "../../../utils/api";
import { encodedURI, removeEmptyValues } from "../../../utils/common";
import { updateDetail } from "./slice";

// Hardcoded endpoints based on backend route implementation
const ENDPOINTS = {
    GET_LIST: 'campaign-by-influencer/list',
    GET_MILESTONES: 'campaign-by-influencer/milestones/',
    VERIFY_PAYMENT: 'campaign-by-influencer/verify-milestone-payment',
    GET_STATS: 'campaign-by-influencer/stats'
}

export const getCampaignsByInfluencer = () => {
    return (dispatch, getState) => {
        dispatch(updateGlobalLoader(true));
        const { limit, page, filters, sort_key, sort_type } = getState().campaignByInfluencerSlice; // Ensure reducer name matches store config

        let queryParams = `?limit=${limit}&page=${page + 1}&sort_key=${sort_key}&sort_type=${sort_type}`;

        if (filters.name) queryParams += `&search=${filters.name}`;

        // Handling complex filters if needed
        let filterObj = {};
        if (filters.type) filterObj.type = filters.type;

        if (Object.keys(filterObj).length > 0) {
            queryParams += `&filters=${JSON.stringify(filterObj)}`;
        }

        api.getApiCall(
            ENDPOINTS.GET_LIST,
            queryParams,
            (respData) => {
                dispatch(updateGlobalLoader(false));
                let res = respData.data;
                console.log(res);

                if (res && res.result) {
                    dispatch(updateDetail({
                        list: res.result.list,
                        totalCount: res.result.total,
                        totalPages: Math.ceil(res.result.total / limit)
                    }));
                }
            },
            (errors) => {
                dispatch(updateGlobalLoader(false));
                console.log("error", errors);
            }
        );
    };
};

export const getCampaignStats = () => {
    return (dispatch) => {
        // We don't necessarily need global loader for stats if it's simultaneous with list
        api.getApiCall(
            ENDPOINTS.GET_STATS,
            '',
            (respData) => {
                let res = respData.data;
                if (res && res.result) {
                    dispatch(updateDetail({
                        stats: res.result
                    }));
                }
            },
            (errors) => {
                console.log("error fetching stats", errors);
            }
        );
    };
};

export const getMilestonesPaymentStatus = (campaignId) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            dispatch(updateGlobalLoader(true));
            api.getApiCall(
                ENDPOINTS.GET_MILESTONES + campaignId,
                '',
                (respData) => {
                    dispatch(updateGlobalLoader(false));
                    resolve(respData);
                },
                (errors) => {
                    dispatch(updateGlobalLoader(false));
                    console.log("error", errors);
                    reject(errors);
                }
            );
        });
    };
};

export const verifyMilestonePayment = (payload) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            dispatch(updateGlobalLoader(true));
            api.postApiCall(
                ENDPOINTS.VERIFY_PAYMENT,
                payload,
                (respData) => {
                    dispatch(updateGlobalLoader(false));
                    resolve(respData);
                },
                (errors) => {
                    dispatch(updateGlobalLoader(false));
                    console.log("error", errors);
                    reject(errors);
                }
            );
        });
    };
};
